import React from 'react';
import {
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import EmptyReportSection from './EmptyReportSection';
import {
  formatRepeatedFailuresGroupedTableValue,
  getRepeatedFailuresGroupedTableFailingAttributes,
} from './repeatedFailuresGroupedTableUtils';
import { reportStyles } from './styles';

export default function FlowListFailuresGroupedTable({
  flows = [],
  emptyMessage = 'No flows reported.',
  showFailingAttributes = true,
}) {
  if (flows.length === 0) {
    return <EmptyReportSection>{emptyMessage}</EmptyReportSection>;
  }

  return (
    <TableContainer>
      <Table size="small" aria-label="Repeated failure flows">
        <TableHead>
          <TableRow>
            <TableCell sx={reportStyles.tableHeaderCell}>Flow</TableCell>
            <TableCell sx={reportStyles.tableHeaderCell}>Test Case</TableCell>
            <TableCell sx={reportStyles.tableHeaderCell}>Flow ID</TableCell>
            {showFailingAttributes && (
              <TableCell sx={reportStyles.tableHeaderCell}>Failing Attributes</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {flows.map((flow, index) => {
            const failingAttributes = getRepeatedFailuresGroupedTableFailingAttributes(flow);

            return (
              <TableRow key={`${flow.flow_id || 'flow'}-${flow.flow_name || index}`}>
                <TableCell sx={reportStyles.wordBreakCell}>
                  {formatRepeatedFailuresGroupedTableValue(flow.flow_name)}
                </TableCell>
                <TableCell sx={reportStyles.wordBreakCell}>
                  {formatRepeatedFailuresGroupedTableValue(flow.test_case)}
                </TableCell>
                <TableCell sx={reportStyles.wordBreakCell}>
                  {formatRepeatedFailuresGroupedTableValue(flow.flow_id)}
                </TableCell>
                {showFailingAttributes && (
                  <TableCell sx={reportStyles.wordBreakCell}>
                    {failingAttributes.length === 0 ? (
                      'N/A'
                    ) : (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {failingAttributes.map((attribute, attributeIndex) => (
                          <Chip
                            key={`${attribute}-${attributeIndex}`}
                            label={formatRepeatedFailuresGroupedTableValue(attribute)}
                            size="small"
                            variant="outlined"
                          />
                        ))}
                      </Box>
                    )}
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
